/**
 * @typedef {import('../../types/LiveReports2').LiveReports2Doc} LiveReports2Doc
 */

/**
 * Is dit rapport vergrendeld voor bewerken? Nodig omdat het slot op meer dan
 * één plek gelezen wordt (opslaan, editor, kopie) en daar dezelfde regel moet
 * gelden.
 *
 * Een vergrendelde template is níet op slot: Deccos bewerkt hem nog. Het slot
 * geldt voor het eigen rapport dat een organisatie ervan maakt (besluit B4:
 * alleen periode, publiceren/delen en verwijderen blijven mogelijk).
 *
 * AI-CONTEXT: See docs/features/meetstandaardrapportage.md (T1)
 * AI-CONTEXT: See docs/pitfalls.md#dev-new-gate-field-reaches-one-reader
 *
 * @param {Pick<LiveReports2Doc, 'Locked' | 'IsTemplate'> | null | undefined} report
 * @returns {boolean}
 */
const isReportLocked = (report) => report?.Locked === true && report?.IsTemplate !== true;

export default isReportLocked;
